import React, { useEffect, useState } from 'react';
import { Container, Button, Switch, Title, Dialog, Input } from '@bsf/force-ui';
import { X, Check, Plus, ArrowRight, Package } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';
import { Link } from "../../router/index"
import { __ } from "@wordpress/i18n";
import { routes } from "../../admin/settings/routes";

const OnboardingBuild = ({ setCurrentStep }) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {
        setEmail(uaelSettingsData.user_email);

        history.pushState(null, "", window.location.href);

        const handleBackButton = (event) => {
            event.preventDefault();
            localStorage.setItem('currentStep', '2');
            window.location.reload();
        };
    
        window.addEventListener('popstate', handleBackButton);
    
        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };

    }, [uaelSettingsData.user_email]);

    return (
        <div className="bg-background-primary border-[0.5px] border-subtle rounded-xl shadow-sm mb-6 p-8" style={{ maxWidth: '55%' }}>
            <div className="flex items-start uael-display-flex">
                {/* Left Content */}
                <div className="flex flex-col items-start" style={{ paddingRight: '35px' }}>
                    <h1 className="text-text-primary m-0 mb-2" style={{ fontSize: '1.6rem', lineHeight: '1.3em' }}>
                        {__("You're all set!🚀", "uael")}
                    </h1>
                    <span className="text-md font-medium text-text-tertiary m-0 mb-4 uael-88-width" style={{ lineHeight: '1.6em' }}>

                    { uaelSettingsData.is_lite_active ? (
                        <>
                            {__(
                                "Start creating headers, footers, or pages with UAE and take your website to the next level",
                                "uael"
                            )}
                        </>
                    ) : (
                        <>
                            {__(
                                "Start creating amazing designs with UAE and take your website to the next level",
                                "uael"
                            )}
                        </>
                    )}
                    </span>
                    <span className="font-bold m-0 pt-2">
                        {__("Here’s how to get started:", "uael")}
                    </span>

                    { uaelSettingsData.is_lite_active ? (
                        <ol className="list-decimal text-text-tertiary text-sm" style={{ marginLeft: '1.4em', lineHeight: '1.6em', paddingBottom: '0.5rem' }}>
                            <li>{__('Click on “Create” button', 'uael')}</li>
                            <li>{__('Use the Elementor editor to customize your header, footer, page or post according to your preferences', 'uael')}</li>
                            <li>{__('Use UAE widgets for your designs', 'uael')}</li>
                            <li>{__('Click “Publish” to make it live', 'uael')}</li>
                        </ol>
                    ) : (
                        <ol className="list-decimal text-text-tertiary text-sm" style={{ marginLeft: '1.4em', lineHeight: '1.6em', paddingBottom: '0.5rem' }}>
                            <li>{__('Click on “Create New Page” button', 'uael')}</li>
                            <li>{__('Use the Elementor editor to customize your page/post according to your preferences', 'uael')}</li>
                            <li>{__('Use UAE widgets to design your pages.', 'uael')}</li>
                            <li>{__('Click “Publish” to make it live', 'uael')}</li>
                        </ol>
                    )}
                </div>

                {/* Right Content - Image */}
                <div className="w-1/2" style={{ textAlign: 'end' }}>
                    <img
                        alt="Build"
                        className="w-full object-contain"
                        style={{ height: '210px', width: 'auto' }}
                        src={`${uaelSettingsData.build_banner}`}
                        loading="lazy"
                    />
                </div>
            </div>
            <div className='flex flex-row gap-1 pb-4 uael-display-flex'>
                { uaelSettingsData.is_lite_active ? (
                    <>
                        <Button
                            icon={<ArrowRight />}
                            iconPosition="right"
                            variant="primary"
                            className="bg-[#6005FF] uael-remove-ring mr-2"
                            style={{
                                backgroundColor: "#6005FF",
                                transition: "background-color 0.3s ease",
                            }}
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                    "#4B00CC")
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                    "#6005FF")
                            }
                            onClick={() => {
                                window.open(
                                    uaelSettingsData.uael_hfe_post_url,
                                    "_blank"
                                );
                            }}
                        >
                            {__("Create Header/Footer", "uael")}
                        </Button>
                        <Button
                            icon={<Plus />}
                            iconPosition="right"
                            variant="outline"
                            className="uael-remove-ring"
                            style={{
                                color: "#6005FF",
                                borderColor: "#6005FF",
                            }}
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.color =
                                    "#000000") &&
                                (e.currentTarget.style.borderColor =
                                    "#000000")
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.color =
                                    "#6005FF") &&
                                (e.currentTarget.style.borderColor =
                                    "#6005FF")
                            }
                            onClick={() => {
                                window.open(
                                    uaelSettingsData.elementor_page_url,
                                    "_blank"
                                );
                            }}
                        >
                            {__("Create New Page", "uael")}
                        </Button>
                    </>
                ) : (
                    <Button
                        icon={<Plus />}
                        iconPosition="right"
                        variant="primary"
                        className="bg-[#6005FF] uael-remove-ring"
                        style={{
                            backgroundColor: "#6005FF",
                            transition: "background-color 0.3s ease",
                        }}
                        onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor =
                            "#4B00CC")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                            "#6005FF")
                        }
                        onClick={() => {
                            window.open(
                                uaelSettingsData.elementor_page_url,
                                "_blank"
                            );
                        }}
                    >
                        {__("Create New Page", "uael")}
                    </Button>
                )}

                <Link
                    to={routes.dashboard.path}

                >
                    <Button
                        icon={<ArrowRight />}
                        iconPosition="right"
                        variant="ghost"
                        className="uael-remove-ring"
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.color =
                                "#000000") &&
                            (e.currentTarget.style.borderColor =
                                "#000000")
                        }
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.color =
                                "#6005FF") &&
                            (e.currentTarget.style.borderColor =
                                "#6005FF")
                        }
                    >
                        {__("Go To Dashboard", "uael")}
                    </Button>
                </Link>

            </div>
        </div>
    )
}

export default OnboardingBuild;